import React, { useMemo } from 'react'
import { View, useWindowDimensions } from 'react-native'
import { useTheme } from '../../../src/theme/useTheme'
import { FormHeader } from './FormHeader'
import { FormRow } from './FormRow'
import { FullHeader } from './FullHeader'
import { FullRow } from './FullRow'
import { getLeagueStandingsTableStyles } from './LeagueStandingsTable.styles'
import type { StandingRow } from '../../../src/leagueDetail'

export type LeagueStandingsTableMode = 'full' | 'form'

interface LeagueStandingsTableProps {
  rows: StandingRow[]
  mode: LeagueStandingsTableMode
}

export const LeagueStandingsTable: React.FC<LeagueStandingsTableProps> = ({ rows, mode }) => {
  const theme = useTheme()
  const { width: windowWidth } = useWindowDimensions()
  const isCompactMobile = windowWidth <= 365
  const styles = useMemo(
    () => getLeagueStandingsTableStyles(theme, windowWidth),
    [theme, windowWidth],
  )
  const kitSize = windowWidth >= 1024 ? 26 : windowWidth >= 768 ? 24 : 22

  return (
    <View style={styles.tableCardWrap}>
      <View style={styles.tableCard}>
        {mode === 'full' ? <FullHeader styles={styles} isCompactMobile={isCompactMobile} /> : <FormHeader styles={styles} />}
        {rows.map((row, index) => {
          const isLast = index === rows.length - 1
          if (mode === 'full') {
            return (
              <FullRow
                key={row.teamId}
                row={row}
                isLast={isLast}
                styles={styles}
                kitSize={kitSize}
                isCompactMobile={isCompactMobile}
              />
            )
          }
          return (
            <FormRow
              key={row.teamId}
              row={row}
              isLast={isLast}
              styles={styles}
              kitSize={kitSize}
            />
          )
        })}
      </View>
    </View>
  )
}
